import { ApiInterceptor } from "../core/apiInterceptor"
import { getRuntimeEnv } from "@/config/env"

const { API_URL } = getRuntimeEnv()

export const authApi = new ApiInterceptor({
    baseURL: API_URL,
    includeToken: false,
    module: 'UserAuthentication',
}).service

export const authLogoutApi = new ApiInterceptor({
    baseURL: API_URL,
    includeToken: true,
    module: 'UserAuthentication',
}).service

export const projectApi = new ApiInterceptor({
    baseURL: API_URL,
    includeToken: true,
    module: 'BuilderProjects',
}).service

export const propertyApi = new ApiInterceptor({
    baseURL: API_URL,
    includeToken: true,
    module: 'BuilderProjects',
}).service

export const buildersApi = new ApiInterceptor({
    baseURL: API_URL,
    includeToken: true,
    module: 'Builders',
}).service

export const storageApi = new ApiInterceptor({
    baseURL: API_URL,
    includeToken: true,
    module: 'Storage',
}).service
